module.exports = __webpack_public_path__ + "img/nu.bf9cb836.svg";